import { Collection as AttachmentsCollection } from '@/components/attachment/collection'
import { AttachmentResourceType } from '@/types'

interface Props {
  eventId: string
}

export const EditImages = ({ eventId }: Props) => {
  return (
    <>
      <AttachmentsCollection
        filters={{ nameEq: 'images', resourceIdEq: eventId, resourceTypeEq: AttachmentResourceType.Event }}
        pageSize={10}
        title="Images"
        createable
        deleteable
        fixedHeight
      />
    </>
  )
}
